export default "__VITE_ASSET__CWp5dPPc__"